import { render, staticRenderFns } from "./FeeRateEditor.vue?vue&type=template&id=8c13c9ac&scoped=true"
import script from "./FeeRateEditor.vue?vue&type=script&lang=js"
export * from "./FeeRateEditor.vue?vue&type=script&lang=js"
import style0 from "./FeeRateEditor.vue?vue&type=style&index=0&id=8c13c9ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c13c9ac",
  null
  
)

export default component.exports